"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfirmDialog = void 0;
var react_1 = __importStar(require("react"));
var ConfirmDialog_1 = require("./ConfirmDialog");
/**
 * useConfirmDialog
 *
 * Provides a promise-based, imperative confirmation API built on top of
 * the Fabric UI `ConfirmDialog`. Designed to replace `window.confirm`
 * without restructuring existing handler logic significantly.
 *
 * @example
 * const { confirm, dialog } = useConfirmDialog();
 *
 * const onDelete = async () => {
 *   const ok = await confirm({
 *     title: "Delete layer",
 *     message: "Are you sure you want to delete this layer?",
 *     variant: "error",
 *     confirmText: "Delete",
 *   });
 *   if (ok) handleDelete();
 * };
 *
 * return <>{content}{dialog}</>;
 */
exports.useConfirmDialog = function () {
    var _a = react_1.useState(null), state = _a[0], setState = _a[1];
    var resolverRef = react_1.useRef(undefined);
    var resolve = react_1.useCallback(function (value) {
        var resolver = resolverRef.current;
        resolverRef.current = undefined;
        setState(function (current) { return (current ? __assign(__assign({}, current), { hidden: true }) : current); });
        if (resolver) {
            resolver(value);
        }
    }, []);
    var confirm = react_1.useCallback(function (options) {
        // If a previous prompt is still pending, resolve it as cancelled before
        // opening a new one to avoid leaking unresolved promises.
        if (resolverRef.current) {
            resolverRef.current(false);
            resolverRef.current = undefined;
        }
        return new Promise(function (promiseResolve) {
            resolverRef.current = promiseResolve;
            setState(__assign(__assign({}, options), { hidden: false }));
        });
    }, []);
    var handleConfirm = react_1.useCallback(function () { return resolve(true); }, [resolve]);
    var handleCancel = react_1.useCallback(function () { return resolve(false); }, [resolve]);
    var dialog = (react_1.default.createElement(ConfirmDialog_1.ConfirmDialog, { hidden: state ? state.hidden : true, title: state ? state.title : '', message: state ? state.message : '', subText: state ? state.subText : undefined, variant: state ? state.variant : 'default', confirmText: state ? state.confirmText : undefined, cancelText: state ? state.cancelText : undefined, onConfirm: handleConfirm, onCancel: handleCancel }));
    return { confirm: confirm, dialog: dialog };
};
